import React from 'react';
import { FormattedMessage } from 'react-intl';

import { CONTACT_URL } from '../config';
import ErrorSummary from './ErrorSummary';

const propTypes = {};

function ServerErrorSummary({ children, innerRef, ...props }) {
  return (
    <ErrorSummary {...props} ref={innerRef}>
      {children || (
        <FormattedMessage
          id="checkout.unknownServerError"
          defaultMessage="An error occurred and your cart could not be processed correctly. Please {contactUsLink} us to resolve it."
          values={{
            contactUsLink: (
              <a href={CONTACT_URL}>
                <FormattedMessage
                  id="payment.contact"
                  defaultMessage="Contact"
                />
              </a>
            ),
          }}
        />
      )}
    </ErrorSummary>
  );
}

ErrorSummary.propTypes = propTypes;

export default React.forwardRef((props, ref) => (
  <ServerErrorSummary {...props} innerRef={ref} />
));
